// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hAPpK","tabListWrap":"_2D1OFE","tablist":"_2YEZQF","tab":"_1fcjbN","selected":"_2Npcn2","tabpannel":"NvXHWQ","panelDescription":"_26sM24","selectedTabPanel":"AfpJuP"};